import { Stack, Typography, Box, useTheme } from '@mui/material';
import CompareChip from 'src/components/chip/compare-chip';
import { formatCurrency } from 'src/utils/format-currency';
import { useLocales } from 'src/locales';
import { useCurrentWorkspace } from 'src/context/reducers/app-settings';

type DatagridDiffCellProps = {
    value: any;
    compareChip: number;
    unit?: string;
    colors?: {
        dark: string;
        light: string;
    };
    invertedColor?: boolean;
};

const DEFAULT_COLORS = {
    dark: '#a64b7b',
    light: '#880E4F'
};

const DatagridDiffCell = ({
    value,
    compareChip,
    unit,
    colors = DEFAULT_COLORS,
    invertedColor = false,
}: DatagridDiffCellProps) => {
    const theme = useTheme();
    const { currentLang } = useLocales();
    const locale = currentLang.value || 'fr-FR';
    const workspace: any = useCurrentWorkspace();
    const currency = workspace?.currency || 'EUR';

    const displayValue =
        unit === "currency"
            ? formatCurrency(value, currency, locale, true, 1)
            : value;

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: 1 }}
        >
            <Box sx={{ flex: 1, textAlign: 'right' }}>
                <Typography variant="caption" sx={{ ml: 2 }}>
                    {displayValue}{unit && unit !== "currency" ? ` ${unit}` : ''}
                </Typography>
            </Box>
            <CompareChip value={compareChip} invertedColor={invertedColor} />
        </Stack>
    );
};

export default DatagridDiffCell;
